module.exports = __webpack_public_path__ + "static/lcc-logo-e29150e4f62957ea6949b5103994de0d.svg";